import { Routes, Route, Navigate } from "react-router-dom";
import MainLayout from "./layouts/MainLayout";
import RequestDemo from "./pages/signup/RequestDemo";
import AuthCallback from "./pages/signup/component/AuthCallback";


export default function App() {
  return (
    <Routes>
      <Route element={<MainLayout />}>
        <Route path="/" element={<RequestDemo />} />
        <Route path="/request-demo" element={<RequestDemo />} />
        <Route path="/auth/callback" element={<AuthCallback />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Route>
    </Routes>
  );
}
